import styled from 'styled-components';

import { Card } from '@xingternal/card';
import { mediaConfined } from '@xingternal/layout-tokens';
import { scale150, space4XL, spaceL, spaceM, spaceS, spaceXL, xdlColorTextSecondary } from '@xingternal/tokens';
import { BodyCopy, Headline, Hero } from '@xingternal/typography';

export const Container = styled.div`
  margin-bottom: ${space4XL};
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const SalaryCard = styled(Card)`
  margin-bottom: ${spaceL};
  padding: ${spaceXL};
  width: 100%;

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const AverageSalary = styled(Hero)`
  font-weight: 700;
  margin: 0px 0px ${spaceXL};
  margin-bottom: ${spaceS};
  padding: 0px;
  font-size: ${scale150};
  line-height: 1.2;

  @media ${mediaConfined} {
    margin-bottom: ${spaceM};
  }
`;

export const SalaryRoleDescription = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
`;
